import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useHistory, useParams } from 'react-router-dom';

import { STATUS_PENDING_PAYMENT, STATUS_AVAILABLE } from '../order/constants';
import { Loading } from '../components';

//import Checkout from './Checkout';

const loadOrder = async (reference, cb) => {
  const { data } = await axios.get('/api/orders/' + reference);
  cb(data);
};

const setupCartEmulator = order => ({
  items: order.items.filter(item => item.status === STATUS_AVAILABLE),
  total: order.total_amount,
  country: 'GB',
  currency: 'gbp',
  shown: false,
  prepareForServer: () => {},
  clear: () => {},
  update: () => {},
});

const PayOrder = ({ user }) => {
  const history = useHistory();
  const { reference } = useParams();
  const [order, setOrder] = useState();
  const [cartEmulator, setCartEmulator] = useState({});

  useEffect(() => {
    loadOrder(reference, setOrder);
  }, [reference]);

  useEffect(() => {
    if (!order) {
      return;
    }

    if (order.status !== STATUS_PENDING_PAYMENT) {
      return history.push('/orders');
    }

    setCartEmulator(setupCartEmulator(order));
  }, [order?.id]);

  if (!order || !cartEmulator?.items?.length) {
    return <Loading />;
  }

  return null;
  //return (
    //<Checkout
      //{...{
        //user,
        //editable: false,
        //cart: cartEmulator,
        //order,
        //readOnly: true,
      //}}
    ///>
  //);
}

export default PayOrder;
